import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import { getConnectedDevices, getStatisticMessages, getTotalMessages } from '@infuse/api/e-connector/statistics';
import { EconnectorStatistics, mapToDomain } from '@infuse/e-connector/dashboard/domain';

export const useStatistics = () => {
  const query = useQuery<EconnectorStatistics>({
    queryKey: ['statistics'],
    queryFn: async () => {
      const [messages, totalMessages, connectedDevices] = await Promise.all([
        getStatisticMessages({}), // past 5 hours only
        getTotalMessages({}),
        getConnectedDevices({})
      ]);
      return mapToDomain(messages, totalMessages, connectedDevices);
    }
  });

  const statistics = computed(() => {
    return (
      query.data.value || {
        totalMessages: 0,
        centralSystems: { connected: 0, total: 0 },
        chargingStations: { connected: 0, total: 0 },
        messageStatsLast5Hours: []
      }
    ); // to avoid nulls
  });

  return {
    ...query,
    statistics
  };
};
